module.exports = __webpack_public_path__ + "img/iot-title.e5416eab.png";